import type { QueryClient } from "@tanstack/react-query"
import { createRouter } from "@tanstack/react-router"
import { PageSkeleton } from "@/components/app/states"
import { RouteError } from "@/components/shell/route-states"
import type { TranslationKey } from "@/i18n/keys"
import { routeTree } from "./routeTree.gen"

export interface RouterContext {
  queryClient: QueryClient
}

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: "intent",
    // TanStack Query owns caching; let the router always call loaders.
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: PageSkeleton,
    defaultPendingMs: 300,
    defaultErrorComponent: RouteError,
    scrollRestoration: true,
  })
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
  interface StaticDataRouteOption {
    /** Title of the page for breadcrumbs (translation key). */
    titleKey?: TranslationKey
  }
}
